import { rootApi } from '../rootApi';

export const vehicleDetailInformationApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getVehicleDetailInformation: builder.query({
      query: ({ chassisNo }) => ({
        url: 'v1/vehicledetailinformation/getbychassisno',
        method: 'GET',
        params: { chassisNo }
      }),
      providesTags: ['VehicleDetailInformation']
    }),
    getVehicleCompPdfList: builder.query({ 
      query: ({ chassisNo, language }) => ({
        url: '/v1/sap/getvehiclecomppdflist',
        method: 'GET',
        params: { 
            ChassisNo: chassisNo, 
            Language: language 
        }
      })
    })
  })
});

export const {
  useLazyGetVehicleDetailInformationQuery,
  useLazyGetVehicleCompPdfListQuery

} = vehicleDetailInformationApi;
